export const cashOutCheckListContent = [
  {
    name: 'cashOut',
    title: 'Benefits of a cash-out refi:',
    options: [
      { text: 'Pay for home improvements (like that dream kitchen!)' },
      {
        text: 'Fund a larger purchase, like an investment property or higher education',
      },
      { text: 'Free up money to invest in other areas' },
    ],
  },
  {
    name: 'lowerPayment',
    title: 'Benefits of a cash-out refi:',
    options: [
      { text: 'It may be the cheapest way to borrow money' },
      {
        text: 'Make life more affordable by maximizing your monthly cash flow',
      },
      { text: 'Eliminate high-interest credit card debt' },
    ],
  },
  {
    name: 'fasterPayoff',
    title: 'Benefits of a cash-out refi:',
    options: [
      { text: 'Consolidate your debts to one lower-interest payment' },
      { text: 'Eliminate your overall debt sooner' },
      { text: 'Free up cash to invest and earn more money faster' },
    ],
  },
  {
    name: 'lowerInterestRate',
    title: 'Benefits of a cash-out refi:',
    options: [
      {
        text: 'You can borrow a lot of money at a lower interest rate than most traditional loans',
      },
      { text: 'Consolidate your debts to one lower-interest payment' },
      {
        text: 'Pay off your balances sooner and save on interest in the long term',
      },
    ],
  },
  {
    name: 'notSure',
    title: 'Benefits of a cash-out refi:',
    options: [
      { text: 'It may be the cheapest way to borrow money' },
      {
        text: 'You can borrow a lot of money at a lower interest rate than most traditional loans',
      },
      { text: 'Pay for home improvements (like that dream kitchen!)' },
    ],
  },
]
